(function () {
  const section_instances = new Map();

  function destroy_section(section_id) {
    const entry = section_instances.get(section_id);
    if (!entry) return;
    if (entry.swiper) {
      entry.swiper.destroy(true, true);
    }
    section_instances.delete(section_id);
  }

  function create_section(section_el) {
    if (typeof window.Swiper !== "function") return;

    const section_id = section_el.dataset.sectionId;
    if (!section_id) return;

    destroy_section(section_id);

    const swiper_el = section_el.querySelector("[data-pmc-swiper]");
    if (!swiper_el) return;

    const enable_loop = section_el.dataset.loop === "true";
    const space_between = Number(section_el.dataset.space || 24);
    const space_between_m = Number(section_el.dataset.spaceM || 16);
    const speed = Number(section_el.dataset.speed || 600);
    const initial_slide = Number(section_el.dataset.initial || 0);

    const slide_count = swiper_el.querySelectorAll(".p-mode__slide").length;
    if (slide_count === 0) return;

    const prev_el = section_el.querySelector("[data-pmc-prev]");
    const next_el = section_el.querySelector("[data-pmc-next]");

    const swiper = new window.Swiper(swiper_el, {
      slidesPerView: 2,
      centeredSlides: true,
      loop: enable_loop && slide_count > 2,
      speed: speed,
      grabCursor: true,
      watchSlidesProgress: true,
      slideToClickedSlide: true,
      initialSlide: initial_slide,
      spaceBetween: space_between_m,
      breakpoints: {
        768: {
          spaceBetween: space_between
        }
      },
      navigation:
        prev_el && next_el
          ? { prevEl: prev_el, nextEl: next_el, disabledClass: "p-mode__nav--disabled" }
          : false
    });

    section_instances.set(section_id, { swiper, section_el });
  }

  function init_all_sections() {
    document.querySelectorAll("[data-pmc-section]").forEach((section_el) => {
      create_section(section_el);
    });
  }

  function wait_for_swiper(retry) {
    retry = retry || 0;
    if (typeof window.Swiper === "function") {
      init_all_sections();
      return;
    }
    if (retry > 20) return;
    setTimeout(() => wait_for_swiper(retry + 1), 120);
  }

  document.addEventListener("DOMContentLoaded", () => {
    wait_for_swiper();
  });

  document.addEventListener("shopify:section:load", (event) => {
    const section_el =
      event.target && event.target.closest ? event.target.closest("[data-pmc-section]") : null;
    if (!section_el) return;
    create_section(section_el);
  });

  document.addEventListener("shopify:section:unload", (event) => {
    const section_el =
      event.target && event.target.closest ? event.target.closest("[data-pmc-section]") : null;
    if (!section_el) return;
    destroy_section(section_el.dataset.sectionId);
  });

  document.addEventListener("shopify:block:select", (event) => {
    const slide_el =
      event.target && event.target.closest ? event.target.closest(".p-mode__slide") : null;
    if (!slide_el) return;
    const section_el = slide_el.closest("[data-pmc-section]");
    if (!section_el) return;
    const entry = section_instances.get(section_el.dataset.sectionId);
    if (!entry || !entry.swiper) return;

    if (typeof slide_el.dataset.swiperSlideIndex !== "undefined") {
      entry.swiper.slideToLoop(Number(slide_el.dataset.swiperSlideIndex));
    } else {
      const index = Array.prototype.indexOf.call(slide_el.parentNode.children, slide_el);
      entry.swiper.slideTo(index);
    }
  });
})();
